import React from "react";

const ITEMS = [
  "COLD BEER",
  "HOT GIRLS",
  "FOUR WHEELING",
  "MUD BOGGIN'",
  "TAILGATE NIGHTS",
  "TRUCK YEAH",
  "BACK ROADS",
  "BONFIRES",
];

export default function Marquee() {
  const repeated = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="marquee py-6 border-y-2 border-[#2C332A] bg-[#DD5422]" data-testid="brand-marquee">
      <div className="marquee-track font-anton text-4xl md:text-6xl uppercase text-[#0A0E0B]">
        {repeated.map((t, i) => (
          <span key={i}>{t} <span className="text-[#0A0E0B]/40">★</span></span>
        ))}
      </div>
    </div>
  );
}
